// Copyright (c) 2016 Deere & Company

import 'ag-grid/dist/styles/ag-grid.css';
import 'ag-grid/dist/styles/theme-fresh.css';
import './report-grid.scss';
import React, {PropTypes} from 'react';
import {AgGridReact} from 'ag-grid-react';

const ReportGrid = props =>
    <section className='report-grid ag-fresh'>
        <AgGridReact
            enableColResize={true}
            enableFilter={true}
            enableSorting={true}
            headerHeight={32}
            rowHeight={32}
            {...props}
        />
    </section>;

ReportGrid.displayName = 'ReportGrid';
ReportGrid.propTypes = {
    columnDefs: PropTypes.arrayOf(PropTypes.object).isRequired,
    onGridReady: PropTypes.func.isRequired,
    rowData: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default ReportGrid;



// WEBPACK FOOTER //
// ./src/reports/shared/components/report-grid/index.js